var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.0205 77.5518C76.9162 77.5518 79.2637 75.2043 79.2637 72.3086C79.2637 69.4129 76.9162 67.0654 74.0205 67.0654C71.1248 67.0654 68.7773 69.4129 68.7773 72.3086C68.7773 75.2043 71.1248 77.5518 74.0205 77.5518Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0205 77.5518C76.9162 77.5518 79.2637 75.2043 79.2637 72.3086C79.2637 69.4129 76.9162 67.0654 74.0205 67.0654C71.1248 67.0654 68.7773 69.4129 68.7773 72.3086C68.7773 75.2043 71.1248 77.5518 74.0205 77.5518Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0234 61.9314V60.5156",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3594 64.9709L82.3604 63.9697",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3984 72.3086H85.8143",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3594 79.646L82.3604 80.6472",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0234 82.6855V84.1014",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6848 79.646L65.6836 80.6472",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6424 72.3086H62.2266",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6848 64.9709L65.6836 63.9697",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2551 1.46484H9.65625C8.76953 1.46484 8.05078 2.18359 8.05078 3.07031V12.309H91.9482V3.07031C91.9482 2.18359 91.2295 1.46484 90.3428 1.46484H23.0908",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7371 98.5352H4.26172V14.1049C4.26172 13.1916 5.00215 12.4512 5.91543 12.4512H94.0832C94.9965 12.4512 95.7369 13.1916 95.7369 14.1049V98.5352H95.7371Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7371 43.4281H4.26172V14.1049C4.26172 13.1916 5.00215 12.4512 5.91543 12.4512H94.0832C94.9965 12.4512 95.7369 13.1916 95.7369 14.1049V43.4281H95.7371Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.025 98.5351H12.3359V55.4517C12.3359 54.4905 13.115 53.7114 14.0762 53.7114H42.2848C43.2459 53.7114 44.025 54.4905 44.025 55.4517V98.5351Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.025 61.9312H12.3359V55.4517C12.3359 54.4905 13.115 53.7114 14.0762 53.7114H42.2848C43.2459 53.7114 44.025 54.4905 44.025 55.4517V61.9312Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0486 53.7116H95.7375V90.5149H55.7623C54.3381 90.5149 53.1836 89.3604 53.1836 87.9362V56.2901C53.1836 54.8659 54.3381 53.7114 55.7623 53.7114H72.8221",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50 43.4281V12.4512",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9648 75.3438V80.2334",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3945 75.3438V80.2334",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1797 61.9312V98.5351",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5381 12.4512L15.2578 25.7314",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8203 42.6781L33.9535 23.5449",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4922 35.4999L49.9291 24.063",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3467 12.4512L61.0664 25.7314",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6289 42.6781L79.7621 23.5449",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3008 35.4999L95.7379 24.063",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/p1.ef03fcfeb2f07bc6f48fa87fb1aae3a1.svg";
export { ForwardRef as ReactComponent };